import styled, { createGlobalStyle } from "styled-components"

interface is_settings_showing {
  mobile: boolean
  settings: boolean
  subPage: string
}

export const GlobalStyles = createGlobalStyle<is_settings_showing>`
  body {
    overflow: ${({ mobile, settings, subPage }) =>
      mobile && (settings || subPage === "History") ? "hidden" : "auto"};
  }
  html {
    overflow-y: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
  }
  `
interface gameboard_props {
  isLoading: boolean
  popup: boolean
}
export const GameBoardWrapper = styled.div<gameboard_props>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};
  height: ${({ popup }) => (popup ? "calc(100vh)" : "unset")};
  @media (min-width: 1024px) {
    flex-direction: row-reverse;
    padding: 60px 20px 20px 20px;
    height: ${({ popup }) => (popup ? "calc(100vh)" : "calc(100vh)")};
  }
  .box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
  }
`
